module.exports = __webpack_public_path__ + "static/img/liBgImage3-hover.afb59e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/technicalAdvantages/liBgImage3-hover.png
// module id = v/Hd
// module chunks = 7